<template>
	<div class="news">
		<div class="title">
			<p style="height: 85px;"></p>
			<!-- <img style="width: 188px" src="../../assets/image/match/news-title.png" alt=""> -->
		</div>
		<div class="top-news-one" style="display:flex;padding:0;justify-content:space-between">
			<div class="left-content">
				<div class="flex-center">
					<div class="n-content">
						<div class="news-title text-overflow">{{item.title}}</div>
						<div class="time">{{item.time}}</div>
						<div class="mutline summary">{{item.introduce}}</div>
					</div>
					<a @click="()=>go(item)" href="javascript:void(0);" class="more-btn">查看更多&gt;&gt;</a>
				</div>
			</div>
			<div class="img-box" style="max-height: 300px;overflow:hidden">
				<img v-if="item.photo" :src="`http://i.didaward.cn/prod-api${item.photo}`" />
			</div>
		</div>
		<div class="news-list-box">
			<div class="newslist" v-for="(item, index) in newslist" :key="index" style="margin-top:50px">
				<div class="li-img">
					<img v-if="item.photo" :src="`http://i.didaward.cn/prod-api${item.photo}`" />
				</div>
				<div class="li-text">
					<div style="display:flex;align-items:center;justify-content:space-between">
						<div class="li-title text-overflow">
								{{ item.title }}
						</div>
						<div class="li-time"> {{ item.time }}</div>
					</div>
					<div class="li-content text-overflow" style="margin-bottom:15px">{{ item.introduce }}</div>
					<a  @click="()=>go(item)" href="javascript:void(0);" class="more-btn">查看更多</a>
				</div>
			</div>
		</div>
		<div class="more-infor-line">
			<a @click="goNews" href="javascript:void(0);" class="more-btn">更多新闻详细&gt;&gt;&gt;</a>
		</div>
    </div>
</template>

<script>
import {getNewsList} from "@/api/api.js";
export default {
	name: "index",
	data() {
		return {
			item: {},
			newslist: [{ url: require('../../assets/image/赛事介绍_47.png'), title: '聚焦旭麓新材料|工业设计不止步，大赛经验将落地企业生产', date: '2021-12-06', des: '11月30日下午，2021 DID AWARD(旭麓新材料)国际工业设计大赛（下称“旭麓新材料”）颁奖典礼暨创新设计论坛在文创园就举行。' },
			{ url: require('../../assets/image/赛事介绍_53.png'), title: '聚焦旭麓新材料|工业设计不止步，大赛经验将落地企业生产', date: '2021-12-06', des: '11月30日下午，2021 DID AWARD(旭麓新材料)国际工业设计大赛（下称“旭麓新材料”）颁奖典礼暨创新设计论坛在文创园就举行。' }]
		};
	},
	created() {
		this.getNewsList();
	},
	methods: {
		goNews() {
			// this.$router.push('news')
			const {href} = this.$router.resolve({
        path: "/news",
      });
      window.open(href, '_blank');
		},
		go(item) {
			const { id, title } = item;
      // this.$router.push({
      //   path: "/news/newsdetail",
      //   query: {
      //     id,
      //     title,
      //   },
      // });
      const {href} = this.$router.resolve({
        path: "/news/newsdetail",
        query: {
          id,
          title,
        },
      });
      window.open(href, '_blank');
		},
		getNewsList() {
      getNewsList({pageNum: 1, pageSize: 3}).then(res=>{
        const { total, rows = [] } = res.data;
        this.item = rows[0]
        this.newslist = rows.slice(1)
      })
    },
	},
}
</script>

<style lang="scss" scoped>
.news {
  // background: url('../../assets/image/match/news-bg.jpg') no-repeat center top;
	height: 1178px;
	.title {
		text-align: center;
		margin-bottom: 70px;
		padding-top: 185px;
	}

	.text {
		margin: auto;
		width: 580px;
		// font-weight: bold;
		line-height: 50px;
		text-indent: 2em;
		font-size: 25px;
		color: rgb(31, 0, 2)
	}
	.newslist{
		display:flex;
		justify-content:space-between;
		margin:auto;
	}
}
.left-content {
	width:490px;
	display: flex;
	align-items: center;justify-content: center;
	flex-direction: column;
	margin-right: 75px;
}
.n-content {
	padding-left: 40px;
}
.news-title {
	font-weight:bold;font-size:18px;margin-bottom:10px;line-height: 22px;
}
.summary {
	margin-top: 10px;margin-bottom:15px;color:rgb(31, 0, 2);-webkit-line-clamp: 3;
}
.top-news-one .more-btn {
	display: block;
	background: url('../../assets/image/match/more-bg.jpg') no-repeat center top;
	height: 41px;
	line-height: 41px;
	text-align: right;
	padding-right: 10px;
}
.img-box {flex: 1;}

.news-list-box {
	padding: 0 50px;color: #1e0000;height: 318px;
	.li-img {
		width: 110px;margin-right: 40px;
	}
	.li-text {flex: 1;}
	.li-title {
		font-weight:bold;margin-bottom:15px;width: 750px;
	}
	.li-content {width: 850px;}
	.li-time {margin-left: 10px;}
	.more-btn {
		line-height: 27px;height: 27px;text-align: left;width: 345px;text-indent: 20px;
		background-image: url('../../assets/image/match/more-btn2.png');display: block;
	}
}

.more-infor-line {
	margin-top: 20px;
	.more-btn {
		display: block;text-align: center;font-size: 16px;
		width: 460px;
		margin: auto;
		height: 65px;
		line-height: 45px;
		// border-bottom: 26px solid #25877d;
	}
	height: 65px;
	padding: 20px 0 0;
	// background: #f8f5f0;
}
</style>



// WEBPACK FOOTER //
// src/components/Match/news.vue